// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"c2060723","92":"5ea6046a","99":"1b3f5758","215":"32f1145b","337":"e3e2adad","443":"c4f5c529","479":"eee3e00f","531":"b1f32112","952":"6f7a3e67"}[chunkId] + ".chunk.js";
};